const ReimbursementComponent = () => import('@/views/finance/reimbursement/ReimbursementView')

export default [
    {
        path:'/ReimbursementIndex',
        name:'ReimbursementComponent',
        component:ReimbursementComponent
    }
]